/**
 * L'impegno dei consulenti: in archivio sono ore, a video sono quello che si
 * è pattuito. Una giornata vale 8 ore, come nel resto del gestionale.
 */
export const ORE_PER_GIORNO = 8;

/** Le ore salvate, riportate nell'unità in cui sono state scritte. */
export function impegnoDaOre(ore, unita) {
  if (ore === '' || ore === null || ore === undefined) return '';
  const n = Number(ore);
  if (!Number.isFinite(n)) return '';
  const q = unita === 'giorno' ? n / ORE_PER_GIORNO : n;
  // Niente code di decimali: 24/8 deve restare 3, non 3.0000000000000004
  return String(Math.round(q * 1000) / 1000);
}

/** "3 giornate", "6 ore": come va scritto in elenco. */
export function etichettaImpegnoConsulente(ore, unita) {
  const q = impegnoDaOre(ore, unita);
  if (q === '' || Number(q) === 0) return '';
  const uno = Number(q) === 1;
  const n = String(q).replace('.', ',');
  return unita === 'giorno' ? `${n} ${uno ? 'giornata' : 'giornate'}` : `${n} ${uno ? 'ora' : 'ore'}`;
}
